import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';


import { PIDService } from '../../services/pid.service';
import { UserService } from '../../services/user.service';

@Injectable()
export class HomeResolve implements Resolve<any> {


  constructor(private _user: UserService, private _pidService: PIDService) {

  }

  resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {
    return this._pidService.getFromOwner(this._user.me()['_id']);
  }
}
